import {
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,

} from 'actions/ChangePassword/changePasswordAction';
const initialState = {
  changePasswordDetails: {}
};

export default function changePasswordReducer(
  state = initialState,
  action
) {
  switch (action.type) {

    case CHANGE_PASSWORD_REQUEST:
      return {
        ...state
      };
    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        clientDetails: action.payload
      };
    case CHANGE_PASSWORD_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    case 'CHANGEPASSWORD':
      if (!action.payload) {
        return initialState;
      } else {
        return {
          ...state,
          changePasswordDetails: action.payload
        };
      }
    default:
      return state;
  }
}
